import React, { FC, useMemo } from "react"

import { ActionIcon, Skeleton, Table, Text, UnstyledButton, useMantineTheme } from "@mantine/core"
import { IconDotsVertical } from "@tabler/icons-react"

import { DeviceDocument, useDevices, useGroups } from "../../../contexts/devices-context"
import GroupsTableItem from "./GroupsTableItem"
import { useLanguage } from "../../../contexts/language-context"
import { useMediaQuery } from "@mantine/hooks"

const GroupsTable: FC = () => {

    const { data: groups, loading: loading } = useGroups()
    const { L } = useLanguage()
    const theme = useMantineTheme()
    const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
    const { data: devices, loading: loadingDevices } = useDevices()
    const devicesByGroup = useMemo(
        () =>
            devices.reduce<Record<string, DeviceDocument[]>>(
                (acc, device) => ({
                    ...acc,
                    [device.group]: device.group in acc ? [...acc[device.group], device] : [device],
                }),
                {},
            ),
        [devices],
    )

    return (
        <Table>
            <thead>
                <tr>
                    <th>{L("Name")}</th>
                    {mobile || <th style={{ width: "75%" }}>{L("Devices")}</th>}
                    <th style={{ width: "1%" }} />
                </tr>
            </thead>
            <tbody>
                {(loading || loadingDevices)
                    ? new Array(5).fill(null).map((_, index) => (
                          <tr key={index}>
                              <td>
                                  <Skeleton h={18} w="50%" />
                              </td>
                              {mobile || (
                                  <td>
                                      <Skeleton h={18} w="50%" />
                                  </td>
                              )}
                              <td>
                                  <ActionIcon disabled>
                                      <IconDotsVertical size={20} />
                                  </ActionIcon>
                              </td>
                          </tr>
                      ))
                    : groups.map(group => (
                          <GroupsTableItem group={group} devices={devicesByGroup[group.id]} />
                      ))}
            </tbody>
        </Table>
    )
}

export default GroupsTable
